import jsonReviver from '@booking-services/json-reviver'

export default function (o) {
  if (o) {
    return JSON.parse(JSON.stringify(o), jsonReviver)
  }
}
